export default "__VITE_ASSET__ZvoU9$xV__"